import { useDispatch } from 'react-redux';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import * as actions from './actionCreators';
import { useJspVariables, useAppContext, useLoginFlowState, useDebugRender } from '../hooks';
import { IceIcon, PageContainer } from '../components';
import Button from '@mui/material/Button';

const PageMaxSessionsExceed = () => {
    useDebugRender('PageMaxSessionsExceed');
    const dispatch = useDispatch();
    const { launcher, panelStyle, jspVariables } = useJspVariables();
    const { getLabelFromJspVariables } = useAppContext(jspVariables);
    const { MAX_SESSIONS_EXCEED } = useLoginFlowState();

    const onContinueClick = () => {
        dispatch(actions.logoutUserSessions(
            MAX_SESSIONS_EXCEED.userId,
            MAX_SESSIONS_EXCEED.password,
            MAX_SESSIONS_EXCEED.appKey,
            MAX_SESSIONS_EXCEED.permissions
        ));
    };

    return (
        <PageContainer id="pageMaxSessionsExceed" dataAutomationId="page_max_sessions_exceed">
            <Box style={panelStyle}>
                <IceIcon launcher={launcher} />
                <Typography fontWeight={500}>{getLabelFromJspVariables('max_sessions_exceed_content')}</Typography>
                <Button variant="contained" fullWidth
                    onClick={onContinueClick}
                    data-automation-id="max_sessions_continue_btn">
                    {getLabelFromJspVariables('max_sessions_logout_action')}
                </Button>
            </Box>
        </PageContainer>
    );
};

export default PageMaxSessionsExceed;
